import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 24, color = '#d4af37' }) => {
    return (
        <div className="loading-spinner" style={{ width: size, height: size, borderColor: `${color} transparent transparent transparent` }}></div>
    );
};

export default LoadingSpinner;
